import gql from 'graphql-tag';
export default gql`
  mutation submitCreditCheck($payload: JSON) {
    submitCreditCheck(payload: $payload) {
      id_reference_internal
      status
      result
    }
  }
`;
